import React from 'react';
import { Button } from 'antd';
// Keep the About entry point tiny; the window itself stays lazy-loaded.
export default function WhatsNewLink({ onClose }) {
  return <Button type="link" onClick={() => {
    onClose?.();
    window.dispatchEvent(new Event('srm:whats-new:open'));
  }}>What's new</Button>;
}
